import React from "react"

import { localizer } from '../../../../Translator'

import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import { Backdrop, CircularProgress } from "@material-ui/core"
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core"
import Alert from '@material-ui/lab/Alert'
import ScreenHeading from '../../../common/ScreenHeading';

import { AddressSelector } from "./AddressSelector"

import { SnackbarCustom } from "../../../Utilities/SnackbarCustom";
import Validators from "../../../Utilities/Validators.js";
import PostalCodeMask from "../../../Utilities/PostalCodeMask.js"

import OutboxCli from "../../../../sdk/OutboxCli"

/**
 * Class component to represent sender and recipient data
 */
export class OutboxAddress extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      shipments: [],

      destinationAddress: {
        who: "",
        contact: "",
        phone: "",
        identityCard: "",

        countryIso: "",
        locality: "",
        postalCode: "",

        streetType: "",
        streetName: "",
        streetNumber: "",
        streetComplements: "",
        envelopeBox: [],
      },
      senderAddress: {
        who: "",
        contact: "",
        phone: "",
        identityCard: "",

        countryIso: "",
        locality: "",
        postalCode: "",

        streetType: "",
        streetName: "",
        streetNumber: "",
        streetComplements: "",
        envelopeBox: [],
      },

      productCode: null,
      
      destinationLine1Preview: "",
      destinationLine2Preview: "",
      destinationLine3Preview: "",
      senderLine1Preview: "",
      senderLine2Preview: "",
      senderLine3Preview: "",
      errors: {},
      alertSenderEmpty: "",
      
      errormessage: null,
      isLoading: false,
      //If it comes from multiships, the proposals are already validated there
      isValidedProposalAddress: false,
      
      // Information about the selected product
      productSelected: null
    }
  }

  componentDidMount() {
    this.setState({ shipments: this.props.shipments }, () => {
      let shipment = this.state.shipments && this.state.shipments.length > 0 ? this.state.shipments[0] : null
      if (!shipment) return

      let productSelected = this.props.products.find(p => p.productCode === shipment.features.productCode)

      this.setState({ destinationAddress: shipment.destinationAddress, senderAddress: shipment.senderAddress, productCode: shipment.features.productCode, productSelected: productSelected },
        () => {
          let errors = []
          errors = errors.concat(this.validateAddress(this.state.senderAddress, "SENDER"))
          let alertmessage = errors.length !== 0 ? localizer.AlertSenderEmpty : null
          this.setState({ alertSenderEmpty: alertmessage })
        })
    })
  }

  handleAddress = (address, owner) => {
    if (owner === "RECIPIENT") {
      let shipments = this.state.shipments.map(s => {
        s.destinationAddress = address
        return s
      })
      this.setState({ shipments: shipments, destinationAddress: address })
    } else {
      let shipments = this.state.shipments.map(s => {
        s.senderAddress = address
        return s
      })
      this.setState({ shipments: shipments, senderAddress: address },
        () => {
          let errors = []
          errors = errors.concat(this.validateAddress(this.state.senderAddress, "SENDER"))
          let alertmessage = errors.length !== 0 ? localizer.AlertSenderEmpty : null
          this.setState({ alertSenderEmpty: alertmessage })
        })
    }
  }

  handleMultishipment = (shipments, isValidedProposalAddress) => {
    if (!shipments) return
    if (shipments.length === 0) return
    this.setState({ shipments: shipments, isValidedProposalAddress: isValidedProposalAddress }, () => { this.handleStep() })
  }

  /**
   * Send component data to update parent component state
   */
  handleStep = async (event) => {
    let direction = "next"
    if (event) direction = event.currentTarget.name

    if (direction === "previous") {
      this.props.handleOutboxState(this.state.shipments, null, 3, direction, null)
      return
    }

    let errormessage = ""
    this.state.shipments.forEach((shipment, index) => {
      let errors = []
      errors = errors.concat(this.validateAddress(shipment.senderAddress, "SENDER"))
      errors = errors.concat(this.validateAddress(shipment.destinationAddress, "RECIPIENT"))

      if (errors.length === 0) return
      
      errormessage = localizer.Shipment + " " + (index + 1) + " - "
      errors.forEach(error => {
        errormessage += error + "\n"
      })
    })

    if (errormessage !== "") {
      this.setState({ errormessage: errormessage })
    } else {
      this.props.handleOutboxState(this.state.shipments, null, 3, direction, null)
    }
  }

  getReference = async (shipment, left, top, width, height) => {
    let draftid = shipment.pages.length > 0 ? shipment.pages[0].draftId : null
    let pageFirst = shipment.pages.length > 0 ? shipment.pages[0].pageFirst : 1
    let reference = null
    if (this.props.billable && this.props.billable.billableOptions && this.props.billable.billableOptions.disabledOCR) return
    
    await OutboxCli.DetectReferenceInPage(draftid, pageFirst, left, top, width, height).then(response => {
      if (response !== null && (response.toString().startsWith("[ERR") || response.toString().startsWith("<html>"))) {
        //this.setState({ priceError: response.substring(response.indexOf(' ')) })
      } else {
        reference = this.MultiSpace(response.replace("\t", " "), " ")
      }
    })
    return reference

  }

  // Replace two or more consecutive spaces with a single space
  MultiSpace(text) {
    return text.replace(/ {2,}/g, ' ');
  }

  /* check if the box is valid to take its coordinates
   * It is defined but some of its coordinates are missing
   * Some of its coordinates are negative
   * The defined area is zero (a line, a point
  */
  validateBoxSelector = (Box) => {
    if (!Box.width || !Box.height || !Box.left || !Box.top) return false
    if (Box.width < 0 || Box.height < 0 || Box.left < 0 || Box.top < 0) return false
    if (Box.width === 0 || Box.height === 0 || (Box.left === Box.top)) return false
    
    return true
  }

  validateAddress = (address, target) => {
    let errors = []
    if (!address) {
      errors.push(localizer.AddressErrorEmpty)
      return errors
    }
    
    if (!address.who || address.who === "") errors.push(localizer.AddressErrorWho)
    if (target === "SENDER") {
      let identification = Validators.documentIdentification(address.identityCard)
      if (!identification || (!identification.isValid)) errors.push(localizer.AddressErrorIdentification)
    }
    if (target === "RECIPIENT" && address.identityCard && address.identityCard !== "") {
      let identification = Validators.documentIdentification(address.identityCard)
      if (!identification || (!identification.isValid)) errors.push(localizer.AddressErrorIdentification) 
    }
    /* if (target == "RECIPIENT") {
      if (this.state.productCode === "COI" && address.countryIso.toUpperCase() == "ES") errors.push(localizer.AddressErrorCountryNational)
    } */
    if (!address.countryIso || address.countryIso === "") errors.push(localizer.AddressErrorCountryIso)
    if (!address.locality || address.locality === "") errors.push(localizer.AddressErrorLocality)
    if (!address.postalCode || address.postalCode === "") errors.push(localizer.AddressErrorPostalCode)
    if (!address.streetName || address.streetName === "") errors.push(localizer.AddressErrorStreetName)
    // Note: disabled this restriction: if (!address.streetNumber || address.streetNumber === "") errors.push(localizer.AddressErrorStreetNumber)
    if (address.postalCode && address.postalCode !== "" && address.countryIso && address.countryIso !== "" && (address.countryIso == "ES" || address.countryIso == "PT")) {
      let match = PostalCodeMask.checkPostalCodeMask(address.countryIso, address.postalCode)
      if (match === false) errors.push(localizer.AddressErrorPostalCodeMask)
    }
    if (target === "RECIPIENT"){
      if (this.state.productSelected && this.state.productSelected.scope === "INTERNATIONAL" &&
        (address.countryIso.toUpperCase() === "ES" || address.countryIso.toUpperCase() === "PT")) errors.push(localizer.AddressErrorCountryInternational)
      if (this.state.productSelected && this.state.productSelected.scope === "DOMESTIC" &&
          (address.countryIso.toUpperCase() !== "ES" && address.countryIso.toUpperCase() !== "PT")) errors.push(localizer.AddressErrorCountryDomestic)
    }
    
    if (this.state.productCode === "BUR" && address.who.length > 50) errors.push(localizer.AddressErrorLengthWhoBur)
    if (this.state.productCode !== "BUR" && address.who.length > 100) errors.push(localizer.AddressErrorLengthWho)
    if (address.streetName.length > 100) errors.push(localizer.AddressErrorLengthStreetName)
    
    let messagetarget = target === "RECIPIENT" ? localizer.AddressErrorDestination : localizer.AddressErrorSender
    if (errors.length !== 0) errors.unshift(messagetarget + localizer.AddressError)

    return errors
  }

  handleonClose = () => {
    this.setState({ errormessage: null })
  }

  render() {
 
    return (
      <React.Fragment>
        <Container className="pt-20">
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-address-book icon-button-header mr-20 ml-20"></i>} title={localizer.FillAddressesInfo} />
          <Grid>
            <Alert severity="info" >
              <Typography className="typography-generic color-info" variant="caption" display="inline" gutterBottom>{localizer.FillFormInfo}</Typography>
            </Alert>
          </Grid>
          <Grid container direction="row" justify="flex-start" className="container-generic">
            <AddressSelector
              address={this.state.senderAddress}
              handleAddress={this.handleAddress}
              ownerAddress="SENDER"
              multishipment={false}
              alertSenderEmpty={this.state.alertSenderEmpty}
              handleMultishipment={this.handleMultishipment}
              shipments={this.state.shipments}></AddressSelector>
            <AddressSelector
              address={this.state.destinationAddress}
              handleAddress={this.handleAddress}
              ownerAddress="RECIPIENT"
              draftsSelected={this.props.draftsSelected}
              multishipment={false}
              alertSenderEmpty={this.state.alertSenderEmpty}
              handleMultishipment={this.handleMultishipment}
              shipments={this.state.shipments}
              billable={this.props.billable}
              notNewShipment={this.props.notNewShipment}
              productSelected={this.state.productSelected}></AddressSelector>
          </Grid>

          {/* Step buttons */}
          <Grid container direction="row" className="pt-20">
            <Grid item md={6}>
              <Button className="button-generic secondary" variant="contained" name="previous" onClick={this.handleStep}>{localizer.Previous}</Button>
            </Grid>
            <Grid item md={6}>
              <Button className="button-generic primary" variant="contained" name="next" onClick={this.handleStep}>{localizer.Next}</Button>
            </Grid>
          </Grid>
        </Container>

        {/* Error message for address fields validation */}
        <SnackbarCustom message={this.state.errormessage} severity="error" handleonClose={this.handleonClose} />

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/address/OutboxAddress.js